import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { ThemeContext } from "../../../../.."; // Adjust path if needed
import "./DatePicker.css"; // Optional for styles
import { useTranslation } from "react-i18next";
const CustomButton = ({
    label = "",
    name = "",
    onClick = () => { },
    errors = null,
    mandatory = false,
    disabled = false,
    icon = null,
    buttonText = "",
    style = {},
    handleShow
}) => {
    const { theme } = useContext(ThemeContext);
    const { t } = useTranslation();
    return (
        <div className="custom-button__container">
            {label && (
                <label
                    className={
                        theme === "light"
                            ? "custom-button__label-light"
                            : "datepicker__label"
                    }
                    htmlFor={name}
                >
                    {t(label)}

                </label>
            )}
            <Button
                variant="outline-primary"
                onClick={handleShow}
                disabled={disabled}
                id={name}
                style={{
                    ...style,
                    color: "#fff",         // White text
                    fontSize: "0.875rem",  // Smaller text (14px ~ Bootstrap sm)
                }}
                className="custom-button__field"
            >
                {icon && <span className="datepicker__label">+ </span>}
                {buttonText}
            </Button>

            {errors && errors[name] && (
                <p className="error__message">{errors[name].message}</p>
            )}
        </div>
    );
};

export default CustomButton;
